module.exports = __webpack_public_path__ + "static/Privacy_Policy_14_12_18-9cafd9886e4b144338d01ecf10b6bd15.pdf";